const CHART_TO_TEXT_COLOR = {
  MA5: '#2EC490',
  MA10: '#F6DC93',
  MA20: '#C790FA',
  MB: '#2EC490',
  UP: '#F6DC93',
  DN: '#C790FA',
  VOL: '#2EC490',
  MA5VOL: '#F6DC93',
  MA10VOL: '#C790FA',
  MACD: '#2EC490',
  DIF: '#F6DC93',
  DEA: '#C790FA',
  K: '#2EC490',
  D: '#F6DC93',
  J: '#C790FA',
  WR: '#2EC490',
  RSI: '#2EC490'
}

export default class IndicatorHelper {
  static generateFormatter(indicator) {
    return (data) => {
      const [indicator1, indicator2] = indicator

      const chartText = data.reduce((calc, item) => {
        if (!item.name) return calc
        if (
          [
            'MA5',
            'MA10',
            'MA20',
            'MB',
            'UP',
            'DN',
            'MA5VOL',
            'MA10VOL',
            'DIF',
            'DEA',
            'K',
            'D',
            'J',
            'WR',
            'RSI'
          ].includes(item.seriesName)
        ) {
          calc[item.seriesName] = item.data
        } else {
          calc[item.seriesName] = item.data[1]
        }
        const [_int, _digit] = String(calc[item.seriesName]).split('.')
        calc[item.seriesName] = _digit ? `${_int}.${_digit.slice(0, 4)}` : _int
        return calc
      }, {})

      const indicator1Text = {
        BOLL: ['MB', 'UP', 'DN'],
        MA: ['MA5', 'MA10', 'MA20']
      }[indicator1].reduce((calc, item, index, arr) => {
        return (calc += `<span style='color:${
          CHART_TO_TEXT_COLOR[item]
        };'>${item}:${chartText[item]}</span>${
          index !== arr.length - 1 ? '&nbsp;' : ''
        }`)
      }, '')
      const indicator2Text = {
        VOL: ['VOL', 'MA5VOL', 'MA10VOL'],
        MACD: ['MACD', 'DIF', 'DEA'],
        KDJ: ['K', 'D', 'J'],
        RSI: ['RSI'],
        WR: ['WR']
      }[indicator2].reduce((calc, item, index, arr) => {
        return (calc += `<span style='color:${
          CHART_TO_TEXT_COLOR[item]
        };'>${item}:${chartText[item]}</span>${
          index !== arr.length - 1 ? '&nbsp;' : ''
        }`)
      }, '')
      return `<div style='font-size:12px;'>
        <div>
          ${indicator1Text}
        </div>
        <div style='height:275px'></div>
        <div>
          ${indicator2Text}
        </div>
      </div>`
    }
  }

  static generateSeries(indicator, KLineEntitys) {
    return indicator.reduce((calc, item) => {
      const indicatorToSeries = {
        MA: () => [
          {
            type: 'candlestick',
            // K 线图形样式
            itemStyle: {
              color: '#41B37E',
              borderColor: '#41B37E',
              color0: '#CE4444',
              borderColor0: '#CE4444',
              borderWidth: 1,
              shadowBlur: 0
            },
            // K 线图形高亮样式
            emphasis: {
              itemStyle: {
                borderWidth: 1,
                shadowBlur: 0
              }
            },
            barMinWidth: 2,
            barMaxWidth: 20,
            data: KLineEntitys.map((item) => [
              item.getOpenPrice(),
              item.getClosePrice(),
              item.getLowPrice(),
              item.getHighPrice(),
              item.getDate()
            ])
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'MA5',
            smooth: true,
            lineStyle: {
              color: '#2EC490',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMA5Price())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'MA10',
            smooth: true,
            lineStyle: {
              color: '#F6DC93',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMA10Price())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'MA20',
            smooth: true,
            lineStyle: {
              color: '#C790FA',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMA20Price())
          }
        ],
        BOLL: () => [
          {
            type: 'candlestick',
            // K 线图形样式
            itemStyle: {
              color: '#41B37E',
              borderColor: '#41B37E',
              color0: '#CE4444',
              borderColor0: '#CE4444',
              borderWidth: 1,
              shadowBlur: 0
            },
            // K 线图形高亮样式
            emphasis: {
              itemStyle: {
                borderWidth: 1,
                shadowBlur: 0
              }
            },
            barMinWidth: 2,
            barMaxWidth: 20,
            data: KLineEntitys.map((item) => [
              item.getOpenPrice(),
              item.getClosePrice(),
              item.getLowPrice(),
              item.getHighPrice()
            ])
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'MB',
            smooth: true,
            lineStyle: {
              color: '#2EC490',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMb())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'UP',
            smooth: true,
            lineStyle: {
              color: '#F6DC93',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getUp())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'DN',
            smooth: true,
            lineStyle: {
              color: '#C790FA',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getDn())
          }
        ],
        VOL: () => [
          {
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: 'VOL',
            barMinWidth: 2,
            barMaxWidth: 20,
            barCategoryGap: '20%', // 配置柱子间的间距
            itemStyle: {
              borderWidth: 0,
              shadowBlur: 0,
              shadowColor: 'rgba(0, 0, 0, 0)'
            },
            data: KLineEntitys.map((item, index) => [
              index,
              item.getVolume(),
              item.getClosePrice() >= item.getOpenPrice() ? 1 : -1
            ])
          },
          {
            type: 'line',
            xAxisIndex: 1,
            name: 'MA5VOL',
            yAxisIndex: 1,
            symbol: 'none',
            smooth: true,
            lineStyle: {
              color: '#F6DC93',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMA5Volume())
          },
          {
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: 'MA10VOL',
            symbol: 'none',
            smooth: true,
            lineStyle: {
              color: '#C790FA',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getMA10Volume())
          }
        ],
        MACD: () => [
          {
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: 'MACD',
            barMinWidth: 2,
            barMaxWidth: 20,
            barCategoryGap: '20%', // 配置柱子间的间距
            itemStyle: {
              borderWidth: 0,
              shadowBlur: 0,
              shadowColor: 'rgba(0, 0, 0, 0)'
            },
            data: KLineEntitys.map((item, index) => [
              index + 1,
              item.getMacd(),
              item.getClosePrice() >= item.getOpenPrice() ? 1 : -1
            ])
          },
          {
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: 'DIF',
            symbol: 'none',
            smooth: true,
            lineStyle: {
              color: '#F6DC93',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getDif())
          },
          {
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: 'DEA',
            symbol: 'none',
            smooth: true,
            lineStyle: {
              color: '#C790FA',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getDea())
          }
        ],
        KDJ: () => [
          {
            type: 'line',
            symbol: 'none',
            name: 'K',
            xAxisIndex: 1,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: '#2EC490',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getK())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'D',
            xAxisIndex: 1,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: '#F6DC93',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getD())
          },
          {
            type: 'line',
            symbol: 'none',
            name: 'J',
            xAxisIndex: 1,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: '#C790FA',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getJ())
          }
        ],
        RSI: () => [
          {
            type: 'line',
            name: 'RSI',
            symbol: 'none',
            xAxisIndex: 1,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: '#2EC490',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getRsi())
          }
        ],
        WR: () => [
          {
            type: 'line',
            symbol: 'none',
            name: 'WR',
            xAxisIndex: 1,
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: '#2EC490',
              width: 1
            },
            data: KLineEntitys.map((item) => item.getR())
          }
        ]
      }
      calc.push(...indicatorToSeries[item]())
      return calc
    }, [])
  }
}
